import { NextPage } from 'next';

import SsoSelfJoinRedirect from '../components/_organisms/Auth/SsoSelfJoinRedirect';
import { ssoSelfJoinServerSideProps } from '../utils/ssoSelfJoinSsr';

const CleverLogin: NextPage = () => <SsoSelfJoinRedirect newProvider="clever" />;

export const getServerSideProps = ssoSelfJoinServerSideProps;

export default CleverLogin;
